<template>
    <b-card title="Suggestion de modification">
      
      <b>Nom :</b><br />
      {{ edit_suggest.name }}

      <br /><br />
      <b>Prix :</b><br />
      {{ edit_suggest.price }}

      <br /><br />
      <b>Nom de la marque :</b><br />
      {{ edit_suggest.brand_name }}

      <br /><br />

      <b>Matière :</b><br />
      {{ edit_suggest.material }}

      <br /><br />

      <b>Fabrication :</b><br />
      {{ edit_suggest.manufacturing }}

      <br /><br />
     
      <b>Description :</b><br />
      {{ edit_suggest.description }}

      <br /><br />

       <b>Gallerie photos :</b><br />

      <div >
        <b-avatar
          v-for="(photo, index) in galleryPhotos" :key="index"
          :src="photo"
          class="mr-1 mb-1"
          size="150"
        />
      </div>

      <br /><br />

       <b>Grande photo / video :</b><br />
      <div v-if="edit_suggest.big_photo">
        <div  v-if="edit_suggest.big_photo && (edit_suggest.big_photo.endsWith('.mp4') || edit_suggest.big_photo.endsWith('.webm') || edit_suggest.big_photo.endsWith('.mov'))" >
            <video 
                    autoplay loop playsinline muted>
                <source :src="edit_suggest.big_photo" type="video/mp4">
                Sorry, your browser doesn't support embedded videos.
            </video>
        </div>
         <b-avatar
          v-else 
          :src="edit_suggest.big_photo"
          class="mr-1 mb-1"
          size="150"
        />
       
      
       
      </div>

      <br /><br />

       <b>Photo droite bio :</b><br />
      <div v-if="edit_suggest.bio_photo">
        
         <b-avatar
         
          :src="edit_suggest.bio_photo"
          class="mr-1 mb-1"
          size="150"
        />
       
      
       
      </div>

      <br /><br />

      <b-button v-b-modal.modal-danger  variant="danger">Supprimer</b-button>
      
      <b-button v-b-modal.modal-accept  variant="success">Valider</b-button>


      <b-modal
      id="modal-accept"
      cancel-variant="outline-secondary"
      cancel-title="Non"
      ok-variant="success"
      ok-title="Oui"
      @ok="acceptSuggest()"
      modal-class="modal-success"
      centered
      title="Êtes-vous sûr ?"
    >
      <b-card-text>
        Attention, cette action est irréversible ! Êtes-vous sûr de vouloir accepter cette suggestion ?
      </b-card-text>
    </b-modal>

      <b-modal
      id="modal-danger"
      cancel-variant="outline-secondary"
      cancel-title="Non"
      ok-variant="danger"
      ok-title="Oui"
      @ok="deletePromotion()"
      modal-class="modal-danger"
      centered
      title="Êtes-vous sûr ?"
    >
      <b-card-text>
        Attention, cette action est irréversible ! Êtes-vous sûr de vouloir supprimer cette suggestion ?
      </b-card-text>
    </b-modal>

    </b-card>
    
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton
  },
  data() {
    return {
      edit_suggest:null,
      loaded:false,
      selectedItem:null,
      galleryPhotos:[],
    }
  },
  methods:{
    async acceptSuggest()
    {
      let datas={}
      datas.name=this.edit_suggest.name
      datas.price=this.edit_suggest.price
      datas.brand_name=this.edit_suggest.brand_name
      datas.material=this.edit_suggest.material
      datas.manufacturing=this.edit_suggest.manufacturing
      datas.description=this.edit_suggest.description
      datas.big_photo=this.edit_suggest.big_photo
      datas.bio_photo=this.edit_suggest.bio_photo
      let galleryPhotosJson=[]
      for(let i=0;i<this.galleryPhotos.length;i++)
      {
        galleryPhotosJson.push({photo:this.galleryPhotos[i]})
      }

      datas.gallery_photos=JSON.stringify(galleryPhotosJson)

       await APIRequest.update('glasses',this.edit_suggest.glass.id,datas)
       await this.deletePromotion()
    },
    async deletePromotion()
    {
      this.loading=true
      try {
        await APIRequest.delete('edit-suggests',this.edit_suggest.id)
        
        this.loading=false
        this.$router.push({name:'edit-suggests'})
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'La suggestion a été supprimée !',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        
      } catch (error) {
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }
      
    }
  },
  async mounted()
  {
    this.edit_suggest=await APIRequest.detail('edit-suggests',this.$route.params.id)
    if(this.edit_suggest.gallery_photos)
    {
      let galleryPhotosJson=JSON.parse(this.edit_suggest.gallery_photos)
      this.galleryPhotos=galleryPhotosJson.map(photo => {
        return photo
      })

    }
    this.loaded=true
  }
}
</script>
